import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

declare global {
  interface Window {
    clarity?: (action: string, ...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ClarityService {
  private isInitialized = false;

  constructor(private router: Router) {
    this.initializeClarity();
  }

  /**
   * Initialize Microsoft Clarity with the project ID from environment
   */
  private initializeClarity(): void {
    if (!environment.clarityProjectId || this.isInitialized) {
      return;
    }

    // Inject Clarity script dynamically
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${environment.clarityProjectId}");
    `;
    document.head.appendChild(script);

    this.isInitialized = true;
    this.initializeTracking();
  }

  private initializeTracking(): void {
    // Track route changes for better page view analytics
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (window.clarity) {
          // Track virtual page views
          window.clarity('set', 'page', event.urlAfterRedirects);
        }
      });
  }

  /**
   * Set a custom tag for user identification or segmentation
   * @param key The tag key
   * @param value The tag value
   */
  setTag(key: string, value: string): void {
    if (window.clarity) {
      window.clarity('set', key, value);
    }
  }

  /**
   * Track custom events
   * @param eventName Name of the event to track
   */
  trackEvent(eventName: string): void {
    if (window.clarity) {
      window.clarity('event', eventName);
    }
  }
}
